import type { CmmdRuntimeThreadReplica } from "@cmmd-forge/contracts";

import { WorktreeSetupCard } from "./WorktreeSetupCard";
import { deriveRemoteWorktreeLaunchProgress } from "./remoteWorktreeLaunchProgress";

export function RemoteWorktreeSetupPanel(props: {
  readonly replica: CmmdRuntimeThreadReplica | null;
}) {
  const progress = deriveRemoteWorktreeLaunchProgress(props.replica);
  if (!progress || progress.phase === "done") return null;
  return (
    <WorktreeSetupCard
      progress={progress}
      onCancel={null}
      onUseProjectCheckout={null}
      onEditMessage={null}
    />
  );
}
